import ky from "ky";
import { AppConfigService as Config } from "./app.config.service";
import { CommonService } from "./common.service";

export interface IQueueServiceOptions {
  conversationId: string;
}

interface IQueueService {
  getEstimatedWaitTime: (options: IQueueServiceOptions) => Promise<any>;
}

class GenesysCloudQueueService implements IQueueService {
  async getEstimatedWaitTime(options: IQueueServiceOptions) {
    try {
      const response = await ky
        .post(`${Config.auviousBaseUrl}/api/genesys/gcEstimatedWaitTime`, {
          json: {
            applicationId: Config.applicationId,
            queueId: Config.pcQueueId,
            conversationId: options.conversationId,
          },
        })
        .json();

      return response;
    } catch (ex) {
      throw ex;
    }
  }
}

class QueueServiceCtrl {
  private _instance: IQueueService;
  private _interval;

  init() {
    switch (Config.chatMode) {
      case "genesys-cloud":
      case "genesys-api":
        this._instance = new GenesysCloudQueueService();
        break;
      default:
      // throw "queue-estimate-wait-time-not-supported";
    }
  }

  supportsWaitTime() {
    return (
      Config.queueEstimateWaitTime &&
      ["genesys-cloud", "genesys-api"].includes(Config.chatMode)
    );
  }

  private async getEstimatedWaitTime(
    options: IQueueServiceOptions,
    successCb: (seconds: number) => void,
    errorCb: (error: any) => void
  ) {
    try {
      const response: { estimatedWaitTimeSeconds: number } =
        await this._instance.getEstimatedWaitTime(options);

      successCb(response.estimatedWaitTimeSeconds);
    } catch (error) {
      if (error instanceof ky.HTTPError) {
        const msgStr = await error.response.text();
        let msg: { error: string };
        try {
          msg = JSON.parse(msgStr);
        } catch (ex) {
          msg = { error: msgStr };
        }
        errorCb(msg.error);
      } else {
        errorCb(error);
      }
    }
  }

  async createEstimatedWaitTimeMonitor(
    options: IQueueServiceOptions,
    successCb: (seconds: number) => void,
    errorCb: (error: any) => void
  ) {
    if (!this._instance) {
      this.init();
    }

    let retries = 1;

    if (this._interval) {
      CommonService.timer.clearInterval(this._interval);
      this._interval = null;
    }

    this._interval = CommonService.timer.setInterval(async () => {
      await this.getEstimatedWaitTime(options, successCb, (_) => {
        if (retries > 2) {
          CommonService.timer.clearInterval(this._interval);
          this._interval = null;
          retries = 0;
        }
        retries += 1;
      });
    }, 10 * 1000); // every 10 seconds

    await this.getEstimatedWaitTime(options, successCb, errorCb);
  }

  public destroyMonitor() {
    if (this._interval) {
      CommonService.timer.clearInterval(this._interval);
      this._interval = null;
    }
  }
}

export const QueueService = new QueueServiceCtrl();
